import { Flex, Text } from '@/components/core';
import { WarningDuotoneIcon } from '@/components/icons';

export const SetupRequired = () => {
  return (
    <Flex variant="warning" className="gap-sm p-sm w-full items-center rounded-sm">
      <WarningDuotoneIcon />
      <Text>Setup required</Text>
    </Flex>
  );
};
